import { Link } from 'react-router';
import { useLocale, useT } from '../i18n/locale-context';
import { localePath } from '../i18n/locale-path';

/**
 * «Lotes de tu alerta · Ver todo el catálogo» — heads a list
 * opened through a saved search's `alert=` link (Spain). The filter bar cannot
 * show that filter (it holds several codes, words and regions at once), so
 * without this line the reader would take the narrowed list for the catalogue.
 * The link drops `alert` and keeps every other param.
 */
export function AlertFilterLine({ params }: { params: URLSearchParams }) {
  const t = useT();
  const { locale } = useLocale();
  const next = new URLSearchParams(params);
  next.delete('alert');
  next.delete('page');
  const qs = next.toString();
  return (
    <p
      data-testid="alert-filter-line"
      className="mb-1 mt-3 flex flex-wrap items-center gap-x-2 gap-y-1 text-[13px] text-ink-soft"
    >
      <span className="font-semibold text-ink">{t('catalog.alertFilter.label')}</span>
      <Link
        to={localePath(qs ? `/catalog?${qs}` : '/catalog', locale)}
        className="font-semibold text-brand underline-offset-2 hover:underline"
      >
        {t('catalog.alertFilter.clear')}
      </Link>
    </p>
  );
}
